export default [
  {
    path: "/crm/home",
    name: "CRM",
    component: () => import("@/views/3pl/CRM/index.vue"),
  },
  {
    path: "/crm/customer-registration",
    name: "CustomerRegistration",
    component: () => import("@/views/3pl/CRM/CustomerRegistration.vue"),
  },
  {
    path: "/crm/import-contacts",
    name: "ImportContacts",
    component: () => import("@/views/3pl/CRM/ImportContacts.vue"),
  },
  {
    path: "/crm/customer-engagement",
    name: "CustomerEngagement",
    component: () => import("@/views/3pl/CRM/CustomerEngagement/Home.vue"),
  },
  {
    path: "/crm/blacklisted-contacts",
    name: "BlacklistedContacts",
    component: () =>
      import("@/views/3pl/CRM/CustomerEngagement/BlacklistedContacts.vue"),
  },
  {
    path: "/crm/customer-profile",
    name: "CustomerProfile",
    component: () =>
      import("@/views/3pl/CRM/CustomerProfile/CustomerProfile.vue"),
  },
  {
    path: "/crm/customer/delivery-addresses",
    name: "DeliveryAddresses",
    component: () =>
      import("@/views/3pl/CRM/CustomerProfile/DeliveryAddresses.vue"),
  },
  {
    path: "/crm/pipeline-management",
    name: "PipelineManagement",
    component: () =>
      import("@/views/3pl/CRM/PipelineManagement/PipelineManagement.vue"),
  },
  {
    path: "/crm/pipeline-management/settings",
    name: "PipelineSettings",
    component: () =>
      import("@/views/3pl/CRM/PipelineManagement/PipelineSettings.vue"),
  },
  {
    path: "/crm/promotions",
    name: "Promotions",
    component: () => import("@/views/3pl/CRM/Promotions/Home.vue"),
  },
  {
    path: "/crm/promotions/new",
    name: "PromotionForm",
    component: () => import("@/views/3pl/CRM/Promotions/PromotionForm.vue"),
  },
  {
    path: "/crm/meetings",
    name: "Meetings",
    component: () => import("@/views/3pl/CRM/Meetings/Home.vue"),
  },
  {
    path: "/crm/meetings/new",
    name: "NewMeeting",
    component: () => import("@/views/3pl/CRM/Meetings/NewMeeting.vue"),
  },
  {
    path: "/crm/meetings/edit/:id",
    name: "EditMeeting",
    component: () => import("@/views/3pl/CRM/Meetings/EditMeeting.vue"),
  },
  {
    path: "/crm/meetings/:id",
    name: "SingleMeeting",
    component: () => import("@/views/3pl/CRM/Meetings/SingleMeeting.vue"),
  },
  {
    path: "/crm/settings",
    name: "CrmSettings",
    component: () => import("@/views/3pl/CRM/Settings/Settings.vue"),
  },
];
